import { render, staticRenderFns } from "./WillBeneficiariesStateBenefitsDetails.vue?vue&type=template&id=735f26e2"
import script from "./WillBeneficiariesStateBenefitsDetails.vue?vue&type=script&lang=js"
export * from "./WillBeneficiariesStateBenefitsDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports